import { FC } from "react";
import _ from "lodash";
import { classNames, wrapImage } from "utils";
import clsx from "clsx";
import { Colors } from "_graphql/data";
import { getContrastTextColor } from "utils/colors";

interface AvatarProps {
  src?: string;
  alt: string;
  size?: "sm" | "md" | "lg" | "xl" | "2xl";
  disabled?: boolean;
  color?: string;
}

const Avatar: FC<AvatarProps> = ({
  src,
  alt,
  size = "sm",
  disabled,
  color,
}) => {
  const textColor = color ? getContrastTextColor(color) : "text-gray-500";
  const bgColor = color ? color : "bg-gray-200";

  if (src?.length) {
    return !disabled ? (
      wrapImage(
        <img
          className={classNames(
            size === "sm" ? "h-10 w-10 " : "",
            size === "md" ? "h-14 w-14 " : "",
            size === "lg" ? "h-20 w-20 " : "",
            size === "xl" ? "h-28 w-28 " : "",
            size === "2xl" ? "h-36 w-36" : "",
            "rounded-full object-cover z-0"
          )}
          src={src}
          alt={alt}
        />
      )
    ) : (
      <img
        className={classNames(
          size === "sm" ? "h-10 w-10 " : "",
          size === "md" ? "h-14 w-14 " : "",
          size === "lg" ? "h-20 w-20 " : "",
          size === "xl" ? "h-28 w-28 " : "",
          size === "2xl" ? "h-36 w-36" : "",
          "rounded-full object-cover z-0"
        )}
        src={src}
        alt={alt}
      />
    );
  }
  return (
    <div
      style={{ backgroundColor: bgColor }}
      className={clsx(
        size === "sm" ? "h-10 w-10 " : "",
        size === "md" ? "h-14 w-14 " : "",
        size === "lg" ? "h-20 w-20 " : "",
        size === "xl" ? "h-28 w-28 " : "",
        "rounded-full flex items-center justify-center bg-gray-200"
      )}
    >
      <span style={{ color: textColor }} className={clsx("text-sm", textColor)}>
        {_.chain(alt)
          .split(" ")
          .slice(0, 2)
          .map((s) => s.charAt(0))
          .join("")
          .upperCase()
          .value()}
      </span>
    </div>
  );
};

export default Avatar;
